import { QueryKey } from "@tanstack/react-query";

export const TeamsCacheKey: QueryKey = ['teams'];
export const KeyMetricsCache2 = {
  StrengthRecovery: 'keyMetrics-strength-recovery',
  Fatigue: 'keyMetrics-fatigue',
}
export const KeyExamCache = {
  FreshExam: {
    table: 'key-exam-fresh',
    avg: 'key-exam-fresh-avg',
  },
  PostExam: {
    table: 'key-exam-post',
    avg: 'key-exam-post-avg',
  },
  ArmPrimer: {
    table: 'key-exam-arm-primer',
    avg: 'key-exam-arm-primer-avg',
  },
}
export const KeyAccountabilityCache = {
  table: 'key-accountability',
  avg: 'key-accountability-avg',
};
export const KeyWellnessCache = {
  table: 'key-wellness',
  avg: 'key-wellness-avg',
}

export const KeyActionItemsCache = 'key-action-items';

interface CacheOpts {
  page: number;
  recordsPerPage: number;
  sortBy: string;
  sortOrder: string;
}

export const CacheKeysTables = (mainCacheKey: string, secondaryCache: QueryKey = [], cacheOpts?: CacheOpts, ): QueryKey => {
  let cacheBaseTable: QueryKey = [];
  if(cacheOpts){
    const {page, recordsPerPage, sortBy, sortOrder} = cacheOpts;
    cacheBaseTable = [{
      page,
      recordsPerPage,
      sortBy,
      sortOrder,
    }];
  }
  return [
    mainCacheKey,
    ...secondaryCache,
    ...(cacheBaseTable.length > 0 ? cacheBaseTable : []),
  ]
}


export const TIMES_CACHE = {
  DEFAULT_CACHE_TIME : 1000 * 60 * 5,
  DEFAULT_STALE_TIME : 1000 * 60 * 2,
}
